{
  "collect": "検体採取",
  "track": "検体追跡",
  "accession": "受付番号",
  "barcode": "バーコード",
  "status": {
    "ordered": "オーダー済み",
    "collected": "採取済み",
    "inTransit": "搬送中",
    "received": "受領済み",
    "processing": "検査中",
    "resulted": "結果報告済み",
    "rejected": "Rejected",
    "in_transit": "搬送中"
  },
  "title": "Specimens",
  "loading": "Loading specimens…",
  "errorState": "Could not load specimens.",
  "emptyState": "No specimens for this patient.",
  "noRejectionReason": "Rejected — no reason recorded",
  "columns": {
    "accession": "Accession",
    "type": "Type",
    "status": "Status",
    "collected": "Collected",
    "received": "Received",
    "location": "Location"
  }
}
